import { render, staticRenderFns } from "./role-page.vue?vue&type=template&id=4a222603"
import script from "./role-page.vue?vue&type=script&lang=js"
export * from "./role-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a222603')) {
      api.createRecord('4a222603', component.options)
    } else {
      api.reload('4a222603', component.options)
    }
    module.hot.accept("./role-page.vue?vue&type=template&id=4a222603", function () {
      api.rerender('4a222603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Roles/role-page.vue"
export default component.exports